





















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import { PageHeader } from "sitewhere-ide-components";

import { VCard, VCardText } from "vuetify/lib";

import {
  ITenantEngineConfiguration,
  IMicroserviceSummary,
  ITenant
} from "sitewhere-rest-api";

@Component({
  components: { VCard, VCardText, PageHeader }
})
export default class TenantEnginePlugin extends Vue {
  @Prop() readonly configuration!: ITenantEngineConfiguration;

  /** Get microservice information */
  get tenant(): ITenant | null {
    return this.configuration ? this.configuration.tenant : null;
  }

  /** Get microservice information */
  get microservice(): IMicroserviceSummary | null {
    return this.configuration ? this.configuration.microservice : null;
  }

  /** Get header displayed at top of page */
  get header(): string | null {
    return this.tenant && this.microservice
      ? `${this.microservice.name} Configuration for Tenant '${this.tenant.name}'`
      : null;
  }
}
